import React from 'react'
import CardTitle from './CardTitle'
import Card from 'components/base/Card'
import { Format } from 'common/utils/format'
import { kycNeedsVerifying } from 'common/services/useKycStatus'
import { useFlags } from 'flagsmith/react'
import useAddress from 'common/hooks/useAddress'
import GenerateLetterOfCertification from './GenerateLetterOfCertification'
import { useDefaultSubscription } from 'common/services/useDefaultSubscription'

type AddressCardProps = {
  className?: string
}

const AddressCard: React.FC<AddressCardProps> = ({ className }) => {
  const { subscriptionDetail } = useDefaultSubscription()
  const hasAddress = !!subscriptionDetail?.address?.postal_code
  const { feature_letter_of_certification } = useFlags([
    'feature_letter_of_certification',
  ])

  const needsVerify = kycNeedsVerifying(subscriptionDetail)
  const address = useAddress()
  return (
    <>
      <div className={className}>
        <Card
          footer={
            hasAddress && (
              <>
                <hr />
                <div className='flex-row align-items-center'>
                  <div className='flex-fill text-sm'>
                    <div className='fw-bold ms-2'>Forwarding address</div>
                    <div className=' ms-2'>
                      {Format.address(subscriptionDetail.address)}
                    </div>
                  </div>
                </div>
              </>
            )
          }
          footerClassName='p-5'
        >
          <div className='flex-fill'>
            <CardTitle title={'ADDRESSES'} subtitle={'Your Business Address'} />
            <div className='mt-2 fs-lg'>
              {subscriptionDetail?.company?.legal_name ||
                subscriptionDetail?.company?.trading_name}
              <h3 className='fw-bold'>{address}</h3>
              {feature_letter_of_certification.enabled && !needsVerify && (
                <div className='mt-4'>
                  <GenerateLetterOfCertification className='w-100' />
                </div>
              )}
            </div>
          </div>
        </Card>
      </div>
    </>
  )
}

export default AddressCard
